// extracted by mini-css-extract-plugin
module.exports = {"publicSpendingTrend":"PublicSpendingTrend__publicSpendingTrend__pZjL8","noData":"PublicSpendingTrend__noData__H6+g6"};